// Mock data for All-Out Moving and Junk Removal Website

export const businessInfo = {
  name: "All-Out Moving and Junk Removal",
  phone: "(920) 901-5969",
  email: "Alloutmover1998@gmail.com",
  address: "P.O. Box 102, Mishicot, WI 54228",
  hours: "Mon-Sat: 7:00 AM - 7:00 PM",
  serviceAreas: ["Manitowoc", "Two Rivers", "Sheboygan", "Green Bay", "Appleton", "Surrounding Areas"]
};

export const services = [
  {
    id: 1,
    title: "Professional Moving",
    description: "Accurate, affordable, and trustworthy moving services. We handle your requirements and move dates to ensure complete satisfaction.",
    icon: "Truck",
    features: ["Residential Moving", "Commercial Moving", "Local & Long Distance", "Packing Services"]
  },
  {
    id: 2,
    title: "Junk Removal",
    description: "Fast and efficient junk removal services. We'll clear out unwanted items from your home, office, or property.",
    icon: "Trash2",
    features: ["Furniture Removal", "Appliance Disposal", "Estate Cleanouts", "Construction Debris"]
  },
  {
    id: 3,
    title: "Small Demolition",
    description: "Professional small demolition services for residential and commercial projects. Safe, efficient, and thorough.",
    icon: "Hammer",
    features: ["Interior Demolition", "Shed Removal", "Deck Teardown", "Garage Demolition"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    location: "Manitowoc, WI",
    rating: 5,
    text: "Best, easiest, nicest move! Hard working, respectful, careful guys. Will definitely use them again.",
    date: "2024-11"
  },
  {
    id: 2,
    name: "Michael Peterson",
    location: "Two Rivers, WI",
    rating: 5,
    text: "Absolutely phenomenal! Moving is a big hassle and they made it so easy. Highly recommend.",
    date: "2024-10"
  },
  {
    id: 3,
    name: "Linda Martinez",
    location: "Sheboygan, WI",
    rating: 5,
    text: "These guys are by far the best movers we have ever utilized. None of our furniture was damaged.",
    date: "2024-09"
  },
  {
    id: 4,
    name: "Robert Williams",
    location: "Green Bay, WI",
    rating: 5,
    text: "Very professional service. When an item was damaged, they took care of the problem immediately by compensating me.",
    date: "2024-08"
  },
  {
    id: 5,
    name: "Jennifer Davis",
    location: "Manitowoc, WI",
    rating: 5,
    text: "These guys are absolutely amazing. So nice and efficient. Worked crazy hard to get everything moved quickly.",
    date: "2024-07"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What areas do you serve?",
    answer: "We serve Manitowoc, Two Rivers, Sheboygan, Green Bay, Appleton, and all surrounding areas in Wisconsin."
  },
  {
    id: 2,
    question: "How do I get a quote?",
    answer: "You can call us at (920) 901-5969 or fill out our online quote form. We'll provide a free, no-obligation estimate based on your specific needs."
  },
  {
    id: 3,
    question: "Are you licensed and insured?",
    answer: "Yes, we are a registered carrier and broker with FMCSA (DOT# 3310412) and fully insured for your peace of mind."
  },
  {
    id: 4,
    question: "Do you offer same-day service?",
    answer: "We strive to accommodate urgent requests. Call us to check availability for same-day or next-day service."
  },
  {
    id: 5,
    question: "What items can you remove?",
    answer: "We can remove furniture, appliances, electronics, yard waste, construction debris, and most household items. Contact us for specific items."
  },
  {
    id: 6,
    question: "Do you provide packing materials?",
    answer: "Yes, we offer packing services and materials including boxes, tape, bubble wrap, and protective padding."
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Experienced Team",
    description: "Licensed carrier (DOT# 3310412) with years of professional moving experience.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Chamber Member",
    description: "2 years a part of Chamber of Commerce, committed to our local business community.",
    icon: "Building2"
  },
  {
    id: 3,
    title: "Best of Lakeshore",
    description: "5 years elected Best of the Lakeshore Business - your trusted choice.",
    icon: "Trophy"
  },
  {
    id: 4,
    title: "Affordable Pricing",
    description: "Competitive rates with transparent pricing and no hidden fees.",
    icon: "DollarSign"
  },
  {
    id: 5,
    title: "Fully Insured",
    description: "Your belongings are protected with comprehensive insurance coverage.",
    icon: "Shield"
  },
  {
    id: 6,
    title: "Local Experts",
    description: "Proud to serve the Lakeshore community and surrounding areas.",
    icon: "MapPin"
  }
];

// Mock form submission
export const submitQuoteRequest = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Quote request submitted:', formData);
      const savedRequests = JSON.parse(localStorage.getItem('quoteRequests') || '[]');
      savedRequests.push({ ...formData, id: Date.now(), date: new Date().toISOString() });
      localStorage.setItem('quoteRequests', JSON.stringify(savedRequests));
      resolve({ success: true, message: 'Quote request received! We will contact you shortly.' });
    }, 1000);
  });
};

export const submitContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted:', formData);
      const savedContacts = JSON.parse(localStorage.getItem('contactForms') || '[]');
      savedContacts.push({ ...formData, id: Date.now(), date: new Date().toISOString() });
      localStorage.setItem('contactForms', JSON.stringify(savedContacts));
      resolve({ success: true, message: 'Message sent! We will get back to you soon.' });
    }, 1000);
  });
};
